import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./SubjectOutcomesUIHelpers";

const SubjectOutcomesUIContext = createContext();

export function useSubjectOutcomesUIContext() {
  return useContext(SubjectOutcomesUIContext);
}

export const SubjectOutcomesUIConsumer = SubjectOutcomesUIContext.Consumer;

export function SubjectOutcomesUIProvider({ subjectId, subjectOutcomesUIEvents, children }) {
  initialFilter.filter.subjectId = subjectId; // Konu Id Atanıyor
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openCourseSubjectListPage: subjectOutcomesUIEvents.openCourseSubjectListPage,
    openNewSubjectOutcomePage: subjectOutcomesUIEvents.openNewSubjectOutcomePage,
    openEditSubjectOutcomePage: subjectOutcomesUIEvents.openEditSubjectOutcomePage
  };

  return (
    <SubjectOutcomesUIContext.Provider value={value}>
      {children}
    </SubjectOutcomesUIContext.Provider>
  );
}